import { io } from "socket.io-client";

const serverURL = process.env.REACT_APP_SERVER_URL ?? "http://localhost:8000";

const socket = io(serverURL);

export const useSocket = () => socket;
